/* eslint-disable no-unused-vars */
export interface ISession {
  value: number;
  showValue: number;
}
export enum EnumAssistanceStatus {
  completeInfo = 1, //asistencia sin integrar a GB pero con datos completos
  incompleteInfo = 2, //asistencia sin integrar a GB y con datos incompletos
  integrated = 3, //asitencia integrada en GB
}
export interface IAttendant {
  idAsistencia: number;
  curp: string;
  nombre: string;
  numeroPersona: string;
  segundoNombre: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  fkIdOrigen: number;
  fkIdSesion: number;
  integrado: boolean;
  email: string;
  fechaRegistro: Date;
  idSesionAsistenciaEstatus: EnumAssistanceStatus;
  numeroSesion: number;
  calificacion?: number;
  fkIdJustificante: number | null;
  asistenciaCompleta?: boolean;
  ids: string;
  partesFaltantes: string;
  fechasInicioSesion?: IAttendancePerDate[];
  fkIdCornerUser: number;
  unidadOrganizacional?: string;
  calificacionHistorial?: ICalificacionHistorial[];
}

export interface IAttendancePerDate {
  parte: number;
  fechaRegistro: Date;
}

export interface IGetDuplicatesParams {
  yearId: number;
  localizadorId: number;
}

export interface IGetDuplicatesDetailsParams extends IGetDuplicatesParams {
  numeroPersona: string;
}

export interface IDuplicateAttendanceSession {
  nombreSesion: string;
  idLocalizador: number;
  nombreInstructor: string;
}

export interface IEventAndSessionData {
  eventName: string;
  locatorId: number;
  sessionName: string;
  yearId: number;
  fkObjectIdExt: string;
}

export interface IReporteAsistenciaSession {
  descripcion?: string;
  fechaInicioSesion?: string | Date;
  fechaFinSesion?: string | Date;
  masDelNoventaDeAssistencias: boolean;
  participantes: IAttendant[];
  numeroTotalPartesSesion: number;
  participantesIncompletos: boolean;
  totalRecords: number;
}

export interface ISetGradeObj {
  ids: string;
  calificacion: number;
}

export interface ICalificacionHistorial {
  calificacion: number;
}
